<template>
<div>
	<!-- Small label like the Documents filter bar; fixed height keeps unnamed categories aligned -->
	<p class="text-xxs uppercase tracking-wide text-grey-dark font-semibold h-8 mb-1 flex items-center justify-center">
        <span v-if="category.name == ''">
            &nbsp;
        </span>
        <span v-else>
            {{ category.name }}
        </span>
    </p>
	<slot></slot>
</div>
</template>

<script>
export default {
  props: ["category"]
};
</script>
